import Block from "@/components/wrappers/block"
import { GradeLabel } from "../wild-neighbors-register/form-school/grade"
import { SubjectLabel } from "../wild-neighbors-register/form-school/subject"
import { ActivityCard } from "./activity-card"
import Button from "@/common/button/button"

export default function WildNeighborsSingle({ block }) {
  const mapUrl = block.attrs.mapUrl

  return (
    <Block block={block}>
      <h1 className="mb-4">{block.attrs.object.school_name}</h1>
      <p className="font-serif text-2xl align-">
        <svg
          className="relative inline-block w-6 h-6 mr-2 -top-1"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1209_1058)">
            <path
              d="M2.57143 14.5712C2.05714 14.5712 1.71429 14.2284 1.71429 13.7141V12.8569C1.71429 12.4284 1.97143 12.0855 2.4 11.9998L3 11.9141C3.94286 11.6569 4.88571 11.5712 5.91429 11.5712C5.65714 11.0569 5.48571 10.4569 5.31429 9.85693C4.37143 9.85693 3.51429 10.0284 2.57143 10.1998L1.97143 10.3712C0.857143 10.6284 0 11.6569 0 12.8569V13.7141C0 14.9998 1.02857 16.1141 2.31429 16.2855C2.74286 15.5998 3.34286 14.9998 4.11429 14.5712H2.57143Z"
              fill="#B9D232"
            />
            <path
              d="M5.22913 9.34265C5.14341 9.0855 5.14341 8.82836 5.14341 8.57122C5.14341 8.22836 5.14341 7.88551 5.22913 7.54265C4.20056 7.28551 3.42913 6.25693 3.42913 5.14265C3.42913 3.6855 4.54341 2.57122 6.00056 2.57122C6.68627 2.57122 7.28627 2.82836 7.71484 3.25693C8.14341 2.91408 8.6577 2.57122 9.17199 2.31408C8.40056 1.45693 7.28627 0.856934 6.00056 0.856934C3.68627 0.856934 1.71484 2.74265 1.71484 5.14265C1.71484 7.19979 3.2577 8.99979 5.22913 9.34265Z"
              fill="#B9D232"
            />
            <path
              d="M22.0288 10.3712L21.4288 10.1998C20.5717 10.0284 19.6288 9.85693 18.6859 9.85693C18.6002 10.4569 18.3431 10.9712 18.0859 11.5712C19.0288 11.5712 20.0574 11.6569 21.0002 11.9141L21.6002 11.9998C22.0288 12.0855 22.2859 12.4284 22.2859 12.8569V13.7141C22.2859 14.2284 21.9431 14.5712 21.4288 14.5712H19.8859C20.6574 14.9141 21.2574 15.5141 21.6859 16.2855C22.9717 16.1141 24.0002 15.0855 24.0002 13.7141V12.8569C24.0002 11.6569 23.1431 10.6284 22.0288 10.3712Z"
              fill="#B9D232"
            />
            <path
              d="M17.9996 2.57122C19.4567 2.57122 20.571 3.6855 20.571 5.14265C20.571 6.25693 19.7996 7.28551 18.771 7.54265C18.8567 7.88551 18.8567 8.22836 18.8567 8.57122C18.8567 8.82836 18.8567 9.0855 18.771 9.34265C20.7424 8.99979 22.2853 7.19979 22.2853 5.14265C22.2853 2.74265 20.3996 0.856934 17.9996 0.856934C16.7138 0.856934 15.5996 1.45693 14.8281 2.31408C15.3424 2.57122 15.8567 2.82836 16.2853 3.25693C16.7138 2.82836 17.3138 2.57122 17.9996 2.57122Z"
              fill="#B9D232"
            />
            <path
              d="M6.85742 8.57108C6.85742 11.3997 9.17171 13.7139 12.0003 13.7139C14.8288 13.7139 17.1431 11.3997 17.1431 8.57108C17.1431 5.74251 14.8288 3.42822 12.0003 3.42822C9.17171 3.42822 6.85742 5.74251 6.85742 8.57108ZM12.0003 5.14251C13.886 5.14251 15.4288 6.68536 15.4288 8.57108C15.4288 10.4568 13.886 11.9997 12.0003 11.9997C10.1146 11.9997 8.57171 10.4568 8.57171 8.57108C8.57171 6.68536 10.1146 5.14251 12.0003 5.14251Z"
              fill="#B9D232"
            />
            <path
              d="M18.5135 15.8568L14.9992 15.171C13.0277 14.7425 10.9706 14.7425 8.91345 15.171L5.39916 15.8568C4.28488 16.1139 3.42773 17.1425 3.42773 18.4282V20.571C3.42773 22.0282 4.54202 23.1425 5.99916 23.1425H17.9992C19.4563 23.1425 20.5706 22.0282 20.5706 20.571V18.4282C20.5706 17.1425 19.7135 16.1139 18.5135 15.8568ZM18.8563 20.571C18.8563 21.0853 18.5135 21.4282 17.9992 21.4282H5.99916C5.48488 21.4282 5.14202 21.0853 5.14202 20.571V18.4282C5.14202 17.9996 5.39916 17.6568 5.82773 17.571L9.34202 16.8853C10.1992 16.7139 11.142 16.6282 11.9992 16.6282C12.8563 16.6282 13.7992 16.7139 14.6563 16.8853L18.1706 17.571C18.5992 17.6568 18.8563 17.9996 18.8563 18.4282V20.571Z"
              fill="#B9D232"
            />
          </g>
          <defs>
            <clipPath id="clip0_1209_1058">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <span>
          Årskurs: <GradeLabel grade={block.attrs.object.grade} />
        </span>
      </p>
      <p className="font-serif text-2xl">
        <svg
          className="relative inline-block w-6 h-6 mr-2 -top-1"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 16V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H15"
            stroke="#B9D232"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 14H4C3.46957 14 2.96086 14.2107 2.58579 14.5858C2.21071 14.9609 2 15.4696 2 16C2 16.5304 2.21071 17.0391 2.58579 17.4142C2.96086 17.7893 3.46957 18 4 18H5"
            stroke="#B9D232"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 18H11C10.4696 18 9.96086 18.2107 9.58579 18.5858C9.21071 18.9609 9 19.4696 9 20M9 20C9 20.5304 9.21071 21.0391 9.58579 21.4142C9.96086 21.7893 10.4696 22 11 22H22V6H11C10.4696 6 9.96086 6.21071 9.58579 6.58579C9.21071 6.96086 9 7.46957 9 8V20Z"
            stroke="#B9D232"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>
          Ämnen: <SubjectLabel subject={block.attrs.object.subject} />
        </span>
      </p>
      <p className="font-serif text-2xl">
        <svg
          className="relative inline-block w-6 h-6 mr-2 -top-1"
          width="24"
          height="26"
          viewBox="0 0 24 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0868 14.4381C15.4226 14.4558 18.7518 15.2301 21.7761 16.6307C23.0153 17.2045 23.9429 18.3573 23.9616 19.755C23.9665 20.8758 24.1173 22.0477 23.7855 23.0283C23.3455 24.3282 22.0597 25.2771 20.6547 25.3037C14.8907 25.3403 9.12663 25.3041 3.3627 25.3041C1.62325 25.293 0.050183 23.8037 0.0158852 21.9971C0.00631379 20.4843 -0.143639 18.8712 0.713325 17.7541C1.31521 16.9696 2.28815 16.5795 3.23668 16.1916C6.03489 15.0471 9.03395 14.4328 12.0868 14.4381ZM11.9342 16.3523C8.84226 16.3691 5.76153 17.0967 2.95294 18.4044C2.39174 18.6657 1.95129 19.1574 1.93773 19.7634C1.928 20.5007 1.92608 21.2366 1.93087 21.9728C1.94475 22.7106 2.57982 23.3751 3.34761 23.3896C9.10866 23.4261 14.87 23.4261 20.6311 23.3896C21.3715 23.3755 22.0333 22.7405 22.0478 21.9728C22.0526 21.2349 22.0576 20.4969 22.0478 19.7591C22.0258 18.769 20.8512 18.276 19.718 17.8316C17.2894 16.8795 14.6893 16.3662 12.0806 16.3523C12.0318 16.3523 11.983 16.3523 11.9342 16.3523Z"
            fill="#B9D232"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.699 5.39671C17.1922 2.75483 14.678 0.705423 12.0243 0.680219C11.8874 0.67974 11.7507 0.68325 11.6143 0.691864C8.29923 0.902276 5.77109 4.19837 6.23212 7.34466C6.63891 10.1207 9.2567 12.3303 12.0243 12.3127C15.6477 12.2896 18.3317 8.69488 17.699 5.39671ZM8.16969 5.68616C8.53771 3.94512 10.2012 2.61133 11.9621 2.59458C11.9959 2.59442 12.0295 2.59474 12.0634 2.59522C14.9008 2.65823 16.6119 5.89067 15.5049 8.18671C14.6357 9.98965 12.2905 10.8627 10.4699 10.0922C8.81002 9.38968 7.79863 7.44125 8.16969 5.68616Z"
            fill="#B9D232"
          />
        </svg>
        <span>Kontaktperson: {block.attrs.object.contact_name}</span>
      </p>
      {block.attrs.object.information && (
        <>
          <h2 className="mb-4 mt-15">Övrig information</h2>
          <p className="preamble">{block.attrs.object.information}</p>
        </>
      )}
      <div className="flex items-center mb-10 mt-15">
        <h2>Våra aktiviteter</h2>
        <span className="block px-4 py-2 ml-4 bg-summer-green-50 rounded-[32px]">
          {block.attrs.object.activities.length} st
        </span>
      </div>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
        {block.attrs.object.activities.map((activity, index) => {
          return (
            <ActivityCard
              key={index}
              activities={block.attrs?.activities ?? []}
              activity={activity}
            />
          )
        })}
      </div>
      <div className="inline-flex mt-8">
        <Button ariaLabel="Tillbaka" tagName="a" theme="lime" href={mapUrl}>
          Tillbaka
        </Button>
      </div>
    </Block>
  )
}
